export default "__VITE_ASSET__WdpZIF_H__"